import { makeStyles } from '@material-ui/core/styles';

export const useDatePickersStyles = makeStyles(() => ({
  input: {
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderRadius: 5,
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#f1f1f1',
    },
    width: '100%',
  },
  errorText: {
    textAlign: 'right',
    color: 'red',
  },
  helperText: {
    textAlign: 'right',
  },
  image: {
    height: 20,
    width: 20,
  },
}));
